//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamStrediskoSpisovychUzluDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      JKLUSACEK                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-03-09                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.14.1
//AdtGeneratorConfig:[ T:(ginstre) GID:(Web.Set.Des.Ts) V1:(ixs_tre,zkratka,nazev,poznamka,dat_od,dat_do,aktivita,dat_zmena,zmenu_prov,ixs_lpc,ixs_isu,spis_pl,spis_znak,spis_znak_spis,spis_znak_kopie,ixs_su_pod,ixs_fun_pod,spis_graf,spis_graf_v,ico,ixs_ext_ess) V2:() K1:() K2:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamStrediskoSpisovychUzluDesigner
     * 
     * @author JKLUSACEK
     * @since 482.1.0.119
     */
    export class SeznamStrediskoSpisovychUzluDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - ixs_tre */
            public ixs_tre: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GStrediskoSpisovychUzluListDto>;

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamStrediskoSpisovychUzluDesigner>, ixs_tre: string  ): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that, ixs_tre);
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true, this.applyAction );

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamStrediskoSpisovychUzluDesigner>, ixs_tre: string ): Forms.Form {

            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka

            return v_filterForm;
        } // createFilterForm

        static applyAction(that: GContentType<SeznamStrediskoSpisovychUzluDesigner>, ev, ctx): any {
            var filterObj = {
            }
            that.view = new Gordic.Isl.View(that.isl.StrediskoSpisovychUzlu.list({ filters: filterObj }));
            that.grid.ggrid("setData", that.view);
        }

        /**
         * SeznamStrediskoSpisovychUzluDesignerInit
         * 
         * @param {GContentType<SeznamStrediskoSpisovychUzluDesigner>} that
         */
        static SeznamStrediskoSpisovychUzluDesignerInit(that: GContentType<SeznamStrediskoSpisovychUzluDesigner>, ixs_tre: string ) {

            this.SeznamBaseInit(that);
            that.filter = this.createFilter(that, ixs_tre);
            
            that.gridFormat = this.createGridFormatByDataListDescription(that);
            that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that);

            var filterObj: any = {}

            that.view = new Gordic.Isl.View(that.isl.StrediskoSpisovychUzlu.list({ filters: filterObj }), { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem
        } // SeznamStrediskoSpisovychUzluDesignerInit

    }
}
